export default __webpack_public_path__ + "static/media/Botão Cancelar.06feadb5.svg";